import { render, staticRenderFns } from "./PartnerCompanies.vue?vue&type=template&id=77fd2c92"
import script from "./PartnerCompanies.vue?vue&type=script&lang=js"
export * from "./PartnerCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports